// extracted by css-extract-rspack-plugin
export default {"container":"O0tq8","narrow_hidden":"nfxIZ","narrowHidden":"nfxIZ"};